module.exports = __webpack_public_path__ + "static/media/reducer-todo1.b356c4a5.jpg";